var _path, _path2, _path3, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgInstagram(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 35,
    viewBox: "0 0 36 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.72 3.15C22.39 3.15 22.95 3.17 24.79 3.25C26.5 3.33 27.42 3.61 28.04 3.85C28.86 4.17 29.44 4.55 30.05 5.16C30.66 5.77 31.04 6.36 31.36 7.17C31.6 7.79 31.88 8.71 31.96 10.42C32.04 12.27 32.06 12.82 32.06 17.49C32.06 22.16 32.04 22.72 31.96 24.56C31.88 26.27 31.6 27.19 31.36 27.81C31.04 28.63 30.66 29.21 30.05 29.82C29.44 30.43 28.85 30.81 28.04 31.13C27.42 31.37 26.5 31.65 24.79 31.73C22.94 31.81 22.39 31.83 17.72 31.83C13.05 31.83 12.49 31.81 10.65 31.73C8.93999 31.65 8.01999 31.37 7.39999 31.13C6.57999 30.81 5.99999 30.43 5.38999 29.82C4.77999 29.21 4.39999 28.62 4.07999 27.81C3.83999 27.19 3.55999 26.27 3.47999 24.56C3.39999 22.71 3.37999 22.16 3.37999 17.49C3.37999 12.82 3.39999 12.26 3.47999 10.42C3.55999 8.71 3.83999 7.79 4.07999 7.17C4.39999 6.35 4.77999 5.77 5.38999 5.16C5.99999 4.55 6.58999 4.17 7.39999 3.85C8.01999 3.61 8.93999 3.33 10.65 3.25C12.5 3.17 13.05 3.15 17.72 3.15ZM17.72 0C12.97 0 12.37 0.02 10.5 0.11C8.63999 0.19 7.36999 0.49 6.24999 0.92C5.09999 1.37 4.11999 1.97 3.14999 2.94C2.17999 3.91 1.57999 4.89 1.12999 6.04C0.699993 7.15 0.399992 8.43 0.319992 10.29C0.229992 12.16 0.209991 12.75 0.209991 17.51C0.209991 22.26 0.229992 22.86 0.319992 24.73C0.399992 26.59 0.699993 27.86 1.12999 28.98C1.57999 30.13 2.17999 31.11 3.14999 32.08C4.11999 33.05 5.09999 33.65 6.24999 34.1C7.35999 34.53 8.63999 34.83 10.5 34.91C12.37 35 12.96 35.02 17.72 35.02C22.48 35.02 23.07 35 24.94 34.91C26.8 34.83 28.07 34.53 29.19 34.1C30.34 33.65 31.32 33.05 32.29 32.08C33.26 31.11 33.86 30.13 34.31 28.98C34.74 27.87 35.04 26.59 35.12 24.73C35.21 22.86 35.23 22.27 35.23 17.51C35.23 12.75 35.21 12.16 35.12 10.29C35.04 8.43 34.74 7.16 34.31 6.04C33.86 4.89 33.26 3.91 32.29 2.94C31.32 1.97 30.34 1.37 29.19 0.92C28.08 0.49 26.8 0.19 24.94 0.11C23.07 0.02 22.48 0 17.72 0Z",
    fill: "url(#paint0_linear_18_5)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.72 8.51001C12.76 8.51001 8.72998 12.53 8.72998 17.5C8.72998 22.47 12.75 26.49 17.72 26.49C22.69 26.49 26.71 22.47 26.71 17.5C26.71 12.53 22.69 8.51001 17.72 8.51001ZM17.72 23.33C14.5 23.33 11.89 20.72 11.89 17.5C11.89 14.28 14.5 11.67 17.72 11.67C20.94 11.67 23.55 14.28 23.55 17.5C23.56 20.72 20.95 23.33 17.72 23.33Z",
    fill: "url(#paint1_linear_18_5)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M27.07 10.26C28.2298 10.26 29.17 9.3198 29.17 8.16C29.17 7.0002 28.2298 6.06 27.07 6.06C25.9102 6.06 24.97 7.0002 24.97 8.16C24.97 9.3198 25.9102 10.26 27.07 10.26Z",
    fill: "url(#paint2_linear_18_5)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_18_5",
    x1: -43.0725,
    y1: 78.2975,
    x2: 158.261,
    y2: -123.036,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#FEC978"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#FFB3DB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#55E1FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_18_5",
    x1: -43.0725,
    y1: 78.2975,
    x2: 158.261,
    y2: -123.036,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#FEC978"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#FFB3DB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#55E1FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_18_5",
    x1: -43.0725,
    y1: 78.2975,
    x2: 158.261,
    y2: -123.036,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#FEC978"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#FFB3DB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#55E1FF"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstagram);
export default __webpack_public_path__ + "static/media/instagram.bf7ed0eac62c9a75402ae1b0ebf0aaa8.svg";
export { ForwardRef as ReactComponent };